import {
    AutoProduct,
    BundleProduct,
    CommercialProduct,
    CondoProduct,
    cssVar,
    getSize,
    HomeProduct,
    LandlordProduct,
    MotorcycleProduct,
    PleasurecraftProduct,
    RoommateProduct,
    RVProduct,
    TenantProduct,
} from 'metrix-common3';

const getIcon = (productClass, size, color) => {
    switch (productClass) {
        case 'tenant':
            return <TenantProduct size={size} color={color} />;
        case 'home':
            return <HomeProduct size={size} color={color} />;
        case 'auto':
        case 'flux-commauto':
            return <AutoProduct size={size} color={color} />;
        case 'ppackage':
            return <BundleProduct size={size} color={color} />;
        case 'condo':
            return <CondoProduct size={size} color={color} />;
        case 'landlord':
            return <LandlordProduct size={size} color={color} />;
        case 'roommate':
            return <RoommateProduct size={size} color={color} />;
        case 'motorcycle':
            return <MotorcycleProduct size={size} color={color} />;
        case 'rv':
            return <RVProduct size={size} color={color} />;
        case 'pleasurecraft':
            return <PleasurecraftProduct size={size} color={color} />;
        default:
            return <CommercialProduct size={size} color={color} />;
    }
};

const ProductClassIcon = ({ productClass, size }) => {
    const resolvedSize = size && getSize(size);
    return getIcon(productClass, resolvedSize || 25, cssVar.colorPrimary);
};

export default ProductClassIcon;
